import React, { Component } from "react";
import Message from "../Messages";
import "./style.scss";

class MessageList extends Component {
  componentDidUpdate() {
    this.scrollList.scrollTop = this.scrollList.scrollHeight;
  }

  render() {
    const { messages, theme, locale } = this.props;
    return (
      <div className="sc-message-list" ref={el => (this.scrollList = el)}>
        {messages.map((message, i) => {
          return (
            <Message message={message} key={i} theme={theme} locale={locale} />
          );
        })}
      </div>
    );
  }
}

export default MessageList;
